module.exports = function() {
  return new Worker(__webpack_public_path__ + "a6f76c68fc422c4ff84d.worker.js");
};